import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import { reduce } from "et3-type-guards";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import Et3Image from "../../core/et3-Image";
import ET3Circle from "../../core/et3-circle";
import { SIDE_BAR_CONTENT_WIDTH } from "./side-bar-constants";

const PROFILE_TRIGGER_HEIGHT = 125;
const AVATAR_SIZE = 50;
const AVATAR_ROW_HEIGHT = 70;
const USER_INFO_HEIGHT = 140;
const USER_INFO_WIDTH = 300;
const USER_INFO_FONT_SIZE = 16;

const UserInfo = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const user = getCorePersonalStore().user.get();
  const username = reduce(() => user.username, "");
  const userImageName = getCorePersonalStore().userPofilePic.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={USER_INFO_WIDTH}
      height={USER_INFO_HEIGHT}
      fDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={SIDE_BAR_CONTENT_WIDTH}
        height={PROFILE_TRIGGER_HEIGHT}
        fDirection="column"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={SIDE_BAR_CONTENT_WIDTH}
          height={AVATAR_ROW_HEIGHT}
          fDirection="row"
          alignItems="center"
          justifyContent="center"
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <ET3Circle
            withShadow={false}
            size={AVATAR_SIZE}
            color={colors.all.transparent}
            style={{
              borderRadius: AVATAR_SIZE * unitX
            }}
            onClick={() => {}}
          >
            <Et3Image
              type="LOCAL"
              alt={i18n.get("ALKHATTABA_ADMIN")}
              imageName={userImageName}
              size={AVATAR_SIZE}
              onClick={() => {}}
              style={{}}
            />
          </ET3Circle>
        </ET3Div>
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={USER_INFO_FONT_SIZE}
          text={username}
          isSpan={false}
          color={colors.all.white}
          style={{
            margin: 0,
            width: SIDE_BAR_CONTENT_WIDTH * unitX,
            wordWrap: "break-word"
          }}
        />
      </ET3Div>
    </ET3Div>
  );
});
export default UserInfo;
